import React from 'react';
import {connect} from 'react-redux';
import Select from "../../../parts/select";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class TenderRelationshipAddComponent extends CommonTab {

    state = {
        popupItem: {
            tenderid: this.props.name === 'underlying' ? this.props.tenderid : null,
            underlyingtenderid: this.props.name === 'underlying' ? null : this.props.tenderid
        },
        error: false,
        errors: [],
        validateFields: [
            (this.props.name === 'underlying') ? 'underlyingtenderid' : 'tenderid' ]
    };


    constructor(props) {
        super(props);
        if (Object.keys(this.props.popupItem).length) {
            this.state = Object.assign({}, this.state, {popupItem: this.props.popupItem});
        }
    }

    changeState = (name, e) => {
        let temp = this.state.popupItem;
        temp[name] = e.value;
        this.setState({
            popupItem: temp
        });
    };

    render() {
        const {popupItem, error, errors, validateFields} = this.state;
        const {tenders, name} = this.props;
        return (
            <Popup openClose={this.props.close}>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (!('remarks' in popupItem)) {
                            popupItem['remarks'] = ''
                        }
                        this.formValidation(popupItem, validateFields);
                    }}
                >
                    <h3>{this.props.button + (this.props.button === 'Add ' ? 'New ' : '')} Tender Relationship</h3>
                    {error ? <span className={'error'}>This Tender is currently exist</span> : ''}
                    <table className={"table table-striped"} valign={"middle"}>
                        <tbody>
                        <tr>
                            <td>{(name === 'underlying') ? 'Underlying' : 'Overlying'} Tender:</td>
                            <td className={errors.indexOf((name === 'underlying') ? 'underlyingtenderid' : 'tenderid') !== -1 ? 'error' : ''}>
                                <Select
                                    name={(name === 'underlying') ? 'underlyingtenderid' : 'tenderid'}
                                    types={tenders}
                                    className={"form-control"}
                                    value={popupItem[(name === 'underlying') ? 'underlyingtenderid' : 'tenderid']}
                                    optionValue={'tenderid'}
                                    optionName={"tendername"}
                                    onChange={(e) => {
                                        this.changeState(((name === 'underlying') ? 'underlyingtenderid' : 'tenderid'), e.target);
                                    }}
                                />
                                {errors.indexOf(name === 'underlying' ? 'underlyingtenderid' : 'tenderid') !== -1 ?
                                    <span className="errorText">Please set Tender</span> : ''}
                            </td>
                        </tr>
                        <tr>
                            <td>Remarks:</td>
                            <td>
                                <input
                                    type={'text'}
                                    value={popupItem.remarks ? popupItem.remarks : ''}
                                    onChange={(e) => {
                                        this.changeState('remarks', e.target);
                                    }}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                </form>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let popupItem = {};
    ownProps.itemList.forEach(function (item) {
        if (item.tenderrelationshipid == ownProps.id) {
            popupItem = item;
        }
    });

    return {
        tenders: state.tenders,
        popupItem: Object.assign({}, popupItem)
    }
};

const TenderRelationshipAdd = connect(mapStateToProps)(TenderRelationshipAddComponent);
export default TenderRelationshipAdd;
